module.exports = __webpack_public_path__ + "static/img/blog1.f4ebc66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/blog1.jpg
// module id = /f8U
// module chunks = 0